// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I9gu","largestCol":"styles_largestCol__1YuUj","smallestCol":"styles_smallestCol__YD7Z8"};